import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TmOutOfOfficeComponent } from '@teammood/shared/ui/out-of-office';
import { OutOfOfficeSettingsComponent } from './out-of-office/out-of-office-settings.component';
import { IntegrationsComponent } from "./integrations/integrations.component";
import { NotificationConfigComponent } from "./integrations/notificationconfig.component";
import { TmWorkingDaysComponent } from "@teammood/shared/ui/working-days";
import { NotificationTimeSettingsComponent } from "./notification-time/notification-time.component";
import { TmTimeZonePickerComponent } from "@teammood/shared/ui/timezone-picker";
import { TmTimepickerComponent } from "@teammood/shared/ui/timepicker";
import { OrgUnitNameTableCell } from './org-unit-name-table-cell/org-unit-name-table-cell.component';
import { OrgUnitSelector } from './org-unit-selector/org-unit-selector.component';
import { TmTeamSelectComponent } from '@teammood/team';
import { TeamMembersListComponent } from '../team/team-member/team-members-list/team-members-list.component';
import { TeamMembersSetupComponent } from './team-members-setup/team-members-setup.component';
import { TeamSetupComponent } from './team-setup/team-setup.component';
import { FiltersComponent } from './filters/filters.component';
import { DigestsComponent } from './digests/digests.component';
import { DigestDialogComponent } from './digests/digest-dialog/digest-dialog.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltip } from '@angular/material/tooltip';
import { OverlayModule } from '@angular/cdk/overlay';
import { TmPipesModule } from '../shared/util/pipes';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterLink } from "@angular/router";
import {
    KudosRecipientsInputListComponent
} from "../timeline/timeline-item/kudos/create-kudos/kudos-recipients-input-list/kudos-recipients-input-list.component";

@NgModule({
  declarations: [
    OutOfOfficeSettingsComponent,
    IntegrationsComponent,
    NotificationTimeSettingsComponent,
    TeamMembersSetupComponent,
    TeamSetupComponent,
    FiltersComponent,
    DigestsComponent,
  ],
    imports: [
        CommonModule,
        FormsModule,
        TranslateModule,
        TmOutOfOfficeComponent,
        OverlayModule,
        NotificationConfigComponent,
        TmWorkingDaysComponent,
        ReactiveFormsModule,
        TmTimeZonePickerComponent,
        TmTimepickerComponent,
        KudosRecipientsInputListComponent,
        OrgUnitNameTableCell,
        OrgUnitSelector,
        TmTeamSelectComponent,
        TeamMembersListComponent,
        DigestDialogComponent,
        MatSlideToggleModule,
        MatMenuModule,
        MatTooltip,
        TmPipesModule,
        MatTabsModule,
        RouterLink
    ]
})
export class TmSetupModule{
}